<script setup>
import { useModal } from '@/composables/useModal.js';
import { IconFlag3 } from '@tabler/icons-vue';
import Modal from '@/components/Modal.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormError from '@/components/Forms/FormError.vue';
import { useForm } from '@inertiajs/vue3';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

const props = defineProps({
    url: {
        required: true,
        type: String,
    },
});

const form = useForm({
    comment: null,
});

const { isOpen, dismiss } = useModal(false);

function submit() {
    form.post(props.url, {
        onSuccess: () => dismiss(),
        preserveScroll: true,
    });
}
</script>

<template>
    <button
        @click="isOpen = true"
        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
    >
        <IconFlag3 class="w-4 h-4" />

        <Modal :show="isOpen" @close="dismiss">
            <form action="" @submit.prevent="submit">
                <FormLabel :value="$t('messages.question_review_comment_label')" for="comment" />
                <FormTextarea
                    required
                    rows="3"
                    id="comment"
                    v-model="form.comment"
                    name="comment"
                    type="text"
                    class="mt-1 w-full"
                    style="min-height: 60px"
                />
                <FormError :value="form.errors.comment" class="mt-2" />

                <div class="flex justify-end mt-5">
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </form>
        </Modal>
    </button>
</template>
<script>
export default {
    name: 'QuestionReviewForm',
};
</script>
